import React, { useState } from 'react';
import { Radio, Select, Typography } from 'antd';
import './SurveyThemeOption.scss';
import './surveyBaseStyles.scss';
import Card from '@Utils/Card';
import { useSelector } from 'react-redux';
const { Title } = Typography;
const { Option } = Select;

const templates = [
  {
    name: 'ON_SITE_CLASSIC',
    title: 'On-Site Classic',
  },
  {
    name: 'ON_SITE_MODAL',
    title: 'On-Site Modal',
  },
  {
    name: 'MOBILE_MODAL',
    title: 'Mobile Modal',
  },
];

function ThemeOption({ value, onChange, settingValue }) {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const themeList =
    useSelector((state) => state.channel.surveyTheme.list) || [];

  const template = templates.find(
    (template) => template.name === settingValue?.layout
  );

  function valueProps() {
    return {
      value: value.theme,
      onChange: (val) => {
        if (typeof val['persist'] === 'function') {
          val.persist();
        }

        onChange({
          ...value,
          theme: val,
        });
      },
    };
  }

  return (
    <Card>
      <div className="question-header">
        <span className="section-title">Theme Options</span>
      </div>
      <div
        className="question-content question-with-content"
        style={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          flex: 1,
          padding: 24,
        }}
      >
        <Title level={5} className="head-title">
          Layout Options
        </Title>
        <div className="layout-options">
          <div className="option">
            <label className="option-label">Layout Name</label>
            <div>{template?.title}</div>
          </div>

          {false && (
            <div className="option">
              <label className="option-label">Survey Widget Alignment</label>
              <Radio.Group {...valueProps('alignment', 'value')}>
                <Radio value="BOTTOM_LEFT">Bottom Left</Radio>
                <Radio value="BOTTOM_RIGHT">Bottom Right</Radio>
              </Radio.Group>
            </div>
          )}

          <div className="option">
            <label className="option-label">Choose Theme</label>
            <Select
              {...valueProps('layoutTheme')}
              style={{ width: 249 }}
              placeholder="Select or create a theme"
              dropdownRender={(menu) => <>{menu}</>}
              open={isDropdownVisible}
              onDropdownVisibleChange={setIsDropdownVisible}
            >
              {themeList &&
                themeList?.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.name}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
      </div>
    </Card>
  );
}

export default ThemeOption;
